import { BrowserRouter } from 'react-router-dom'

import { DocumentsContainer } from 'components/documentsContainer/DocumentsContainer'
import { HeroBanner } from 'components/heroBanner/HeroBanner'

import BottomArc from '../components/common/bottomArc/BottomArc'

export function App() {

  return (
    <BrowserRouter>
      <HeroBanner />
      <DocumentsContainer />
      <BottomArc />
    </BrowserRouter>
  )
}
